/**
 * Client checks before a bank-file upload (TMMAPP-0095). Extension and size only — the SPA
 * never parses the file. The cap is tmm-api's documented default (`20 MiB`), not a live config.
 */
export const IMPORT_MAX_BYTES = 20 * 1024 * 1024;

const ACCEPTED = new Set(['csv', 'tsv', 'txt']);

export function importFileProblem(file: { name: string; size: number }): 'type' | 'size' | null {
  const dot = file.name.lastIndexOf('.');
  const extension = dot < 0 ? '' : file.name.slice(dot + 1).toLowerCase();
  if (!ACCEPTED.has(extension)) return 'type';
  if (file.size > IMPORT_MAX_BYTES) return 'size';
  return null;
}
